import { render, staticRenderFns } from "./TransloadAndDeliver.vue?vue&type=template&id=76d5118e"
import script from "./TransloadAndDeliver.vue?vue&type=script&lang=js"
export * from "./TransloadAndDeliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports